import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';


export type EchartsGaugeFormData = QueryFormData &
  EchartsLegendFormData & {
    metric?: string;
    showLabels: boolean;
    rowLimit: number;
    tooltipFormat: string;
    valueFormat: string;
    rangeMax: string;
};

export interface EchartsGaugeChartProps
  extends ChartProps<EchartsGaugeFormData> {
  formData: EchartsGaugeFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsGaugeFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  showLabels: true,
  rowLimit: 10,
  tooltipFormat: '{b}: {c}',
  valueFormat: '{value}%',
  rangeMax: '100',
};

export interface GaugeChartTransformedProps {
  formData: EchartsGaugeFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
}